import React, { useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

export interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

const CustomTabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange, className = '' }) => {
  // Handle URL hash changes and initial load
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1); // Remove the '#' character
      if (hash && tabs.some((tab) => tab.id === hash)) {
        onTabChange(hash);
      }
    };

    // Check hash on component mount
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [tabs, onTabChange]);

  const handleTabClick = (tabId: string) => {
    // Update URL hash
    window.location.hash = tabId;
    // Call the original onTabChange
    onTabChange(tabId);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    handleTabClick(newValue);
  };

  return (
    <Box className={className} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="navigation tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab) => (
          // MUI upper-cases tab labels by default; keep the label's own casing.
          <Tab key={tab.id} label={tab.label} value={tab.id} sx={{ textTransform: 'none' }} />
        ))}
      </Tabs>
    </Box>
  );
};

export default CustomTabs;
